import { Record, CRUD_DELETE_SUCCESS, Identifier } from "react-admin";
import { ICompanyDefaultHosData } from "./defaultHosData";
import {
  CreateCompanyDto,
  UpdateCompanyDto,
  RecordStatus,
  GroupDto,
  RoleDto,
  EldDeviceDto,
} from "./../../data/service-proxies";
import {
  IAppData,
  ICompanyAppData,
  IDropDownAppData,
} from "../reducers/appDataReducer";

export const APP_DATA_RECEIVED = "APP_DATA_RECEIVED";
export const COMPANY_CREATED = "COMPANY_CREATED";
export const COMPANY_UPDATED = "COMPANY_UPDATED";
export const COMPANY_DEACTIVATED = "COMPANY_DEACTIVATED";
export const GROUP_CREATED = "GROUP_CREATED";
export const GROUP_UPDATED = "GROUP_UPDATED";
export const GROUP_DELETED = "GROUP_DELETED";
export const CRUD_STATUS_CHANGE_SUCCESS = "CRUD_STATUS_CHANGE_SUCCESS";
export const ROLE_CREATED = "ROLE_CREATED";
export const ROLE_UPDATED = "ROLE_UPDATED";
export const ELD_ASSIGNED = "ELD_ASSIGNED";
export const ELD_CREATED = "ELD_CREATED";
export const ELD_UPDATED = "ELD_UPDATED";

export type EldAssignedAction = {
  type: string;
  payload: {
    id: Identifier;
    assigned: boolean;
  };
};

export type EldChangedAction = {
  type: string;
  payload: EldDeviceDto;
};

export type CrudDeletedAction = {
  type: string;
  payload: { data: Record };
  requestPayload: { id: Identifier; previousData: Record };
  meta: { resource: string; fetchResponse: string };
};

export const createAppDataReceivedAction = (payload: IAppData) => {
  return { type: APP_DATA_RECEIVED, payload };
};

export const createCompanyCreatedAction = (payload: CreateCompanyDto) => {
  const defaultHosData: Omit<ICompanyDefaultHosData, "companyId"> = {
    odometer: payload.odometer,
    timeZoneId: payload.homeTerminalTimeZone!,
    cycleRules: payload.cycleRules!,
    thirtyMinuteBreakException: payload.thirtyMinuteBreakException!,
    twentyFourHourCycleReset: payload.twentyFourHrCycleReset!,
    dvirWarnings: payload.dvirWarnings!,
    cargoType: payload.cargoType!,
  };
  const company: ICompanyAppData = {
    id: payload.id,
    name: payload.name,
    defaultHosData,
  };
  return { type: COMPANY_CREATED, payload: company };
};

export const createGroupCreatedAction = (payload: GroupDto) => {
  const group: IDropDownAppData<number> = {
    id: payload.id,
    name: payload.name,
  };
  return { type: GROUP_CREATED, payload: group };
};

export const createRoleCreatedAction = (payload: RoleDto) => {
  return { type: ROLE_CREATED, payload };
};

export const createCompanyUpdatedAction = (payload: UpdateCompanyDto) => {
  const defaultHosData: Omit<ICompanyDefaultHosData, "companyId"> = {
    odometer: payload.odometer,
    timeZoneId: payload.homeTerminalTimeZone!,
    cycleRules: payload.cycleRules!,
    thirtyMinuteBreakException: payload.thirtyMinuteBreakException!,
    twentyFourHourCycleReset: payload.twentyFourHrCycleReset!,
    dvirWarnings: payload.dvirWarnings!,
    cargoType: payload.cargoType!,
  };
  const company: ICompanyAppData = {
    id: payload.id,
    name: payload.name,
    defaultHosData,
  };
  return { type: COMPANY_UPDATED, payload: company };
};

export const createGroupUpdatedAction = (payload: GroupDto) => {
  const group: IDropDownAppData<number> = {
    id: payload.id,
    name: payload.name,
  };
  return { type: GROUP_UPDATED, payload: group };
};

export const createRoleUpdatedAction = (payload: RoleDto) => {
  return { type: ROLE_UPDATED, payload };
};

export const createCompanyDeactivatedAction = (payload: UpdateCompanyDto) => {
  const company: ICompanyAppData = {
    id: payload.id,
    name: "",
    defaultHosData: {},
  };
  return { type: COMPANY_DEACTIVATED, payload: company };
};

export const createGroupDeletedAction = (payload: GroupDto) => {
  const group: IDropDownAppData<number> = {
    id: payload.id,
    name: "",
  };
  return { type: GROUP_DELETED, payload: group };
};

export const createCrudStatusChangedAction = (
  payload: Record & { status: RecordStatus }
) => {
  return { type: CRUD_STATUS_CHANGE_SUCCESS, payload };
};

export const createCrudDeletedAction = (
  actionPayload: Omit<CrudDeletedAction, "type">
) => {
  return { ...actionPayload, type: CRUD_DELETE_SUCCESS };
};

export const createEldAssignedAction = (payload: {
  id: Identifier;
  assigned: boolean;
}): EldAssignedAction => {
  return { type: ELD_ASSIGNED, payload };
};

export const createEldCreatedAction = (payload: EldDeviceDto) => {
  return { type: ELD_CREATED, payload };
};

export const createEldUpdatedAction = (payload: EldDeviceDto) => {
  return { type: ELD_UPDATED, payload };
};
